import {
  ChangeDetectorRef,
  Component,
  forwardRef,
  HostBinding,
  Input
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { MonoFieldValueAccessorComponent } from '../mono-field-value-accessor.component';
import { NgClass } from '@angular/common';
import { SdFormLibelleComponent } from '../form-libelle/form-libelle.component';
import { ErrorTranslateService } from '../error-translate-service';
import { BaseFormErrorTranslateService } from '../form-common-error/base-form-error-translate.service';

@Component({
  selector: 'sd-form[textarea]',
  templateUrl: './form-textarea.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SdFormTextareaComponent)
    },
    { provide: BaseFormErrorTranslateService, useClass: ErrorTranslateService }
  ],
  standalone: true,
  imports: [SdFormLibelleComponent, FormsModule, NgClass, ReactiveFormsModule]
})
export class SdFormTextareaComponent
  extends MonoFieldValueAccessorComponent<string>
  implements ControlValueAccessor
{
  constructor(cdRef: ChangeDetectorRef) {
    super(cdRef);
  }
  /**
   * The type to be applied to the input element
   */
  @Input()
  type: 'text' | 'password' | 'number' = 'text';

  /**
   * Default value false, this property, allows to display "*" in the required fields.
   * <b>Important</b> This property does not concern validation
   */
  @Input()
  required = false;

  /**
   * Allows you to limit the number of characters to be entered
   */
  @Input()
  maxlength: number;

  @Input()
  rows: number;

  /**
   * Allows to add a custom addon to the input field (icon or button for example)
   */
  @Input()
  isFormAddon = false;

  @Input() class = '';
  @HostBinding('class')
  get hostClasses(): string {
    return [this.class, this.getClasses()].filter(Boolean).join(' ');
  }

  mappingChildToParent(value: string): string {
    return value;
  }

  mappingParentToChild(value: string): string {
    return value;
  }
}
